module.exports = __webpack_public_path__ + "ru.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/ru.svg
// module id = 1039
// module chunks = 0